import AppContent from './app-content'

export default AppContent
